import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import {success} from "../../utils/Tostify";

const ContactUsOne = ({ show, handleClose }) => {
  const [form, setForm] = useState({
    institution: "",
    website: "",
    email: "",
    address: "",
    state: "",
    city: "",
    zip: "",
    message: ""
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    success("Successful");
    handleClose(); // close modal after submission
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Contact Us</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Institution Name<span className="text-danger">*</span></Form.Label>
            <Form.Control type="text" name="institution" placeholder="Enter Institution Name" value={form.institution} onChange={handleChange} />
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Website URL<span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="website" placeholder="Enter Website URL" value={form.website} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email<span className="text-danger">*</span></Form.Label>
                <Form.Control type="email" name="email" placeholder="Enter Email (.edu)" value={form.email} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Street Address<span className="text-danger">*</span></Form.Label>
            <Form.Control type="text" name="address" placeholder="Enter Address" value={form.address} onChange={handleChange} />
          </Form.Group>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>State<span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="state" placeholder="Enter State" value={form.state} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>City<span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="city" placeholder="Enter City" value={form.city} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>ZIP Code<span className="text-danger">*</span></Form.Label>
                <Form.Control type="text" name="zip" placeholder="Enter ZIP Code" value={form.zip} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Message<span className="text-danger">*</span></Form.Label>
            <Form.Control as="textarea" rows={3} name="message" placeholder="Enter Message" value={form.message} onChange={handleChange} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Send
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ContactUsOne;
